<template>
  <div class="similar-job-card d-flex align-end ga-1">
    <div class="d-flex flex-column ga-1 flex-grow-1">
      <div class="text-body-2 text-textLight">
        {{ job.company }} {{ job.location ? `· ${job.location}` : '' }}
      </div>
      <div class="text-body-1 text-textDarkest">
        {{ job.title }}
      </div>

      <div class="description">
        <DocumentPreviewFieldHtml
          :html="job.description"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import DocumentPreviewFieldHtml from '@ui/components/general/DocumentPreviewFieldHtml/DocumentPreviewFieldHtml.vue';

const props = defineProps({
  job: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped lang="less">
.description {
  max-height: 100px;
  overflow: hidden;
  mask-image: linear-gradient(to bottom, black calc(100% - 30px), transparent);
  -webkit-mask-image: linear-gradient(to bottom, black calc(100% - 30px), transparent);

  :deep(.preview-field) {
    p, h1, h2, h3, > ul, > ol, strong, em, b, i, a {
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;
    }
  }
}
</style>
